/**
 * Pregame View Controller.
 * @requires  GameDayUI.LineupsViewController
 */
define('responsive-gameday/controllers/PregameMatchupViewController',['require','exports','module','Responsive/controllers/ScrollViewController','./LineupViewController','../views/render/PregameMatchupViewRender','Responsive/util/renderComplete','Responsive/util/object','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/util/DateConsts','GameDayCore','GameDayCore/GDModel/enums/events/EventTypes','jquery-when-always/jquery-when-always'],function(require,exports,module){
	var ScrollViewController  = require( 'Responsive/controllers/ScrollViewController' ),
		LineupViewController = require( './LineupViewController' ),
		PregameMatchupViewRender = require( '../views/render/PregameMatchupViewRender' ),
		renderComplete = require( 'Responsive/util/renderComplete' ),
		ReObject = require( 'Responsive/util/object' ),
		resourcePath = require("gameday-resource-path/gameday-resource-path"),
		dateConsts = require( 'GameDayCore/GDModel/enums/util/DateConsts' ),
		GameDayCore = require( 'GameDayCore' ),
		EventEnums = require( 'GameDayCore/GDModel/enums/events/EventTypes' ),
		$ = require( 'jquery-when-always/jquery-when-always' );
	// Add private variables here
	var Superclass,
		rNotValidTeamCode = /tbd|nl|al/,
		pitcherStatsType = "pitcher",
		ensureSeason = function (type, season) {
			return type === "R" || type !== "R" && season && season.season === "2013" ? season : null;
		},
		player_thumb_path = "http://mlb.mlb.com/images/gameday/mugshots/";

	// Add private methods here

	// Constructor
	function PregameMatchupViewController(type) {
		// Call super constructor
		Superclass.constructor.call(this);
		this.viewRender = new PregameMatchupViewRender();
		this.data = {active: 0};
		this.type = type;
		this.active = 0;
	}

	// Prototype Inheritence
	ScrollViewController.spawn(PregameMatchupViewController).define({
		loadView: function () {
			var that = this;

			Superclass.loadView.call(this);
			this.setScrollOpts({
				horizontal : false
			});
			this.setClassName("PregameMatchupViewController");
			this.content;
			$(this.view).on('click', 'nav.secondary li', function (e) {
				that.defaultSwitch = false;
				e.preventDefault();
				e.stopPropagation();
				that.content.setAttribute('data-view', that.active = this.getAttribute('data-view'));
				that.setScroll();
			});
		},

		draw: function () {
			Superclass.draw.call(this);
			this.drawPregame();
		},

		drawSection: function (data) {
			var parent = this.childWrapper,
				team,
				that = this,
				whichLength,
				x;
			console.warn('pre match',data);
			if (!data || !parent) {
				return;
			}

			parent.innerHTML=this.viewRender.render(data.pregame);
		},

		drawPregame: function () {
			var that = this,
				days = dateConsts.days,
				months = dateConsts.months,
				gameLoc = GameDayCore.getCurrent().addGameParams().loc;
			console.warn('pre match',that);
			return;
			this.onBeat = function () {
				var view = that.getView(),
					gameData = GameDayCore.getGameData("gamecenter,linescore"),
					dateArray = (GameDayCore.getCurrent().getDateFragment()),
					start_date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]),
					game = gamecenter.data && gamecenter.data.game || {},
					probables = game.probables,
					lsgame = linescore.data.game || {},
					localGameTime = GameDayCore.getCurrent().localGameTime,
					easternGameTime = GameDayCore.getCurrent().easternGameTime,
					isScheduled = GameDayCore.getCurrent().isScheduled,
					isTeamKnown = !rNotValidTeamCode.test(lsgame.home_code.toLowerCase()),
					isPostponed = linescore.data && linescore.data.game && linescore.data.game.status === 'Postponed',
					currentDate = new Date(),
					showRecords = isPostponed || (localGameTime.getDate() - 2) <= currentDate.getDate() && currentDate.getMonth() >= localGameTime.getMonth() && currentDate.getFullYear() >= localGameTime.getFullYear(),
					/**
					 * For first round and play off games, if the series number is less than 3,
					 * use regular season stats.
					 */
					seriesNum = ~~(linescore.data && linescore.data.game && (linescore.data.game.series_num || linescore.data.game['series-num'])),
					game_type = seriesNum <= 3 || linescore.data.game.game_type === "F" ? 'R' : linescore.data.game.game_type;

				($.whenAlways(probables && probables.home && probables.home.player_id && GameDayCore.getGameData("playerStats", {
					playerId: probables.home.player_id,
					game_type: game_type,
					stats_type: pitcherStatsType
				}) || true, probables && probables.away && probables.away.player_id && GameDayCore.getGameData("playerStats", {
					playerId: probables.away.player_id,
					game_type: game_type,
					stats_type: pitcherStatsType
				}) || true)).always(function (pitcherHome, pitcherAway) {

						var pitcherHomeSeason = pitcherHome && ensureSeason(game_type, ReObject.namespace(pitcherHome.data, 'summary.season')[0]),
							pitcherAwaySeason = pitcherAway && ensureSeason(game_type, ReObject.namespace(pitcherAway.data, 'summary.season')[0]),
								data = {
						pregame : {
							game : {
								blurb : game.previews && game.previews.mlb.blurb,
								date : days[start_date.getDay()] + ', ' + months[start_date.getMonth()] + ' ' + start_date.getDate() + ', ' + start_date.getFullYear(),
								headline : game.previews && game.previews.mlb.headline,
								image : game.photos && game.photos.ipad && 'http://mlb.com' + game.photos.ipad.url,
								status : linescore.data.game.status === 'Delayed Start' ? 'Delayed' : (linescore.data.game.status === 'Preview' || linescore.data.game.status === 'Pre-Game') ? '' : linescore.data.game.status,
								reason : linescore.data.game.status === 'Delayed Start' || linescore.data.game.status === 'Postponed'? linescore.data.game.reason ? ': ' + linescore.data.game.reason : '' : '',
								statusClass : linescore.data.game.status === 'Postponed' && "postponed" || '',
								time : isScheduled && (
										(!localGameTime.getHours() ? 12 : localGameTime.getHours() > 12 ? 
											localGameTime.getHours() - 12 : 
											localGameTime.getHours()
										) + ':' + 
										(localGameTime.getMinutes() >= 10 ? 
											localGameTime.getMinutes() : 
											'0' + localGameTime.getMinutes()
										) + ' ' + (localGameTime.getHours() >= 12 ? 'PM' : 'AM')
									) || 'Time TBD',
								time_zone : isScheduled ? $GDM.data.getActiveGame().timezone : '',
								location : game && game.venueLong,
								park : linescore.data.game.game_pk,
								promotionsLink : gameLoc==="mlb" && isTeamKnown && !isPostponed ? 'http://m.'+linescore.data.game.home_team_name.toLowerCase().replace(/[-\s]/g,'')+'.mlb.com/tickets/promotions/' + dateArray.slice(0,2).join('/') : undefined,
								ticketsLink : gameLoc==="mlb" && isTeamKnown && !isPostponed ? 'http://m.'+linescore.data.game.home_team_name.toLowerCase().replace(/[-\s]/g,'')+'.mlb.com/schedule/list/'+dateArray.slice(0,2).join('/') : undefined, //linescore.data.game.home_name_abbrev.toLowerCase() + '/tickets/?game_pk=' + linescore.data.game.game_pk : undefined,
								url : game.previews && game.previews.mlb.url && game.previews.mlb.url.cid ? '/news/article/' + game.previews.mlb.url.cid : undefined,
								jspath : game.previews && game.previews.mlb.url ? '/js/' + game.id + '/recap/' : ''
							},
							away : {
								isActive : false,
								label : 'away',
								blurb : probables && probables.away.report,
								channels : game.broadcast && (typeof game.broadcast.away.tv === 'object' ? undefined : game.broadcast.away.tv) || undefined,
								file_code : linescore.data.game.away_file_code.toLowerCase(),//linescore.data.game.away_code,
								team_id 		  : linescore.data.game.away_team_id,
								sport_code : 'sport-'+linescore.data.game.away_sport_code.toLowerCase(),
								headline : game.previews && game.previews.away.headline,
								name : linescore.data.game.away_team_name,
								logo : 'http://mlb.mlb.com/images/logos/80x80/' + linescore.data.game.away_file_code + '.png',
								pitcher : !isPostponed && probables && probables.away.lastName && typeof probables.away.lastName === 'string' ? {
									era : pitcherAwaySeason && pitcherAwaySeason.era|| probables.away.era,
									full_name :typeof probables.away.lastName === 'string' ? probables.away.useName + ' ' + probables.away.lastName : 'TBD',
									id : probables.away.player_id,
									last_name : probables.away.lastName,
									mugshot : probables && probables.away.player_id ? resourcePath.get('mugshot',{pid:probables.away.player_id}) : resourcePath.get('mugshotDefault'),
									number : typeof probables.away.number === 'string' ? '#' + probables.away.number : '',
									arm : probables.away.throwinghand,
									losses : pitcherAwaySeason && pitcherAwaySeason.l || probables.away.losses,
									verified : true,
									wins : pitcherAwaySeason && pitcherAwaySeason.w || probables.away.wins
								} : {
									era : '',
									full_name : 'TBD',
									id : '',
									last_name : 'TBD',
									mugshot : resourcePath.get('mugshotDefault'),
									number : '',
									arm : '',
									losses : '',
									tbd : true,
									verified : false,
									wins : ''
								},
								radio : game.broadcast && (typeof game.broadcast.away.radio === 'string' ? game.broadcast.away.radio : null) || null,
								record : showRecords ? linescore.data.game.away_win + '-' + linescore.data.game.away_loss : '',
								shortname : linescore.data.game.away_name_abbrev,
								vs : linescore.data.game.home_name_abbrev
							},

							home : {
								isActive : true,
								label : 'home',
								blurb : probables && probables.home.report,
								channels :game.broadcast && (typeof game.broadcast.home.tv === 'object' ? '' : game.broadcast.home.tv) || undefined,
								headline : game.previews && game.previews.home.headline,
								file_code : linescore.data.game.home_file_code.toLowerCase(),//linescore.data.game.home_code,
								sport_code : 'sport-'+linescore.data.game.home_sport_code.toLowerCase(),//linescore.data.game.home_code,
								team_id : linescore.data.game.home_team_id,
								name : linescore.data.game.home_team_name,
								logo : 'http://mlb.mlb.com/images/logos/80x80/' + linescore.data.game.home_file_code + '.png',
								pitcher : !isPostponed && probables && probables.home.lastName && typeof probables.home.lastName === 'string' ? {
									era : pitcherHomeSeason && pitcherHomeSeason.era || probables.home.era,
									full_name : probables.home.useName + ' ' + probables.home.lastName,
									id : probables.home.player_id,
									last_name : probables.home.lastName,
									mugshot : probables && probables.home.player_id ? resourcePath.get('mugshot',{pid:probables.home.player_id}) : resourcePath.get('mugshotDefault'),
									number : typeof probables.home.number === 'string' ? '#' + probables.home.number : '',
									arm : probables.home.throwinghand,
									losses : pitcherHomeSeason && pitcherHomeSeason.l || probables.home.losses,
									verified : true,
									wins : pitcherHomeSeason && pitcherHomeSeason.w || probables.home.wins
								} : {
									era : '',
									full_name : 'TBD',
									id : '',
									last_name : 'TBD',
									mugshot : resourcePath.get('mugshotDefault'),
									number : '',
									arm : '',
									losses : '',
									tbd : true,
									verified : false,
									wins : ''
								},
								radio : game.broadcast && (typeof game.broadcast.home.radio === 'string' ? game.broadcast.home.radio : undefined) || undefined,
								record : showRecords ? linescore.data.game.home_win + '-' + linescore.data.game.home_loss : '',
								shortname : linescore.data.game.home_name_abbrev,
								vs : linescore.data.game.away_name_abbrev
							},
							teams : []
						}

							};

						// Used for template
						data.pregame.teams = [data.pregame.away, data.pregame.home];
						data.pregame.teams[0].index = 0;
						data.pregame.teams[1].index = 1;
						data.pregame.game.hasPromos = gamecenter.data && (data.pregame.game.promotionsLink || data.pregame.game.ticketsLink);

						// Each teams lineups vs the opposing pitcher over the last 5 years
						$.whenAlways(GameDayCore.getGameData("teamVsPitcher5Y", {
								pitcher_id: data.pregame.home.pitcher.id,
								team_id: linescore.data.game.away_team_id,
								game_type: game_type
							}), GameDayCore.getGameData("teamVsPitcher5Y", {
								pitcher_id: data.pregame.away.pitcher.id,
								team_id: linescore.data.game.home_team_id,
								game_type: game_type
							}), LineupViewController.prototype.getLineupData.call(that, true)).always(function (awayBatters, homeBatters, lineupData) {
								var homeBattersById = {},
									awayBattersById = {},
									lineupHome = lineupData[0],
									lineupAway = lineupData[1];

								if (awayBatters.data) {
									data.pregame.home.pitcher.opposite_team_vs = awayBatters.data.batters.filter(function (batter) {
										awayBattersById[batter.player_id] = batter;
										if (lineupAway && lineupAway.lineupById[batter.player_id]) {
											batter.order = lineupAway.lineupById[batter.player_id].order;
											return true;
										}
										return false;
									})
									if (lineupAway) {
										lineupAway.lineup.forEach(function (batter) {
											if (!awayBattersById[batter]) {
												data.pregame.home.pitcher.opposite_team_vs.push({
													name: lineupAway.lineupById[batter].last_name + ', ' + lineupAway.lineupById[batter].first_name,
													order: lineupAway.lineupById[batter].order
												});
											}
										});
									}
									data.pregame.home.pitcher.opposite_team_vs.sort(function (p1, p2) {
										return p1.order < p2.order ? -1 : 1;
									});
									data.pregame.home.pitcher.opposite_team_vs_improbables = awayBatters.data.batters.filter(function (batter) {
										return !lineupAway || lineupAway && !lineupAway.lineupById[batter.player_id];
									});
								} else {
									delete data.pregame.home.pitcher.verified;
								}

								if (homeBatters.data) {
									data.pregame.away.pitcher.opposite_team_vs = homeBatters.data.batters.filter(function (batter) {
										homeBattersById[batter.player_id] = batter;
										if (lineupHome && lineupHome.lineupById[batter.player_id]) {
											batter.order = lineupHome.lineupById[batter.player_id].order;
											return true;
										}
										return false;
									})
									if (lineupHome) {
										lineupHome.lineup.forEach(function (batter) {
											if (!homeBattersById[batter]) {
												data.pregame.away.pitcher.opposite_team_vs.push({
													name: lineupHome.lineupById[batter].last_name + ', ' + lineupHome.lineupById[batter].first_name,
													order: lineupHome.lineupById[batter].order
												});
											}
										});
									}
									data.pregame.away.pitcher.opposite_team_vs.sort(function (p1, p2) {
										return p1.order < p2.order ? -1 : 1;
									});
									data.pregame.away.pitcher.opposite_team_vs_improbables = homeBatters.data.batters.filter(function (batter) {
										return !lineupHome || lineupHome && !lineupHome.lineupById[batter.player_id];
									});
								} else if (!data.pregame.home.pitcher.verified) {
									delete data.pregame.away.pitcher.verified;
									// $('nav ul.ScrollPanelView-nav.tabs li').eq(1).hide();

								}
								that.drawSection({ pregame: data }, that.type);

								renderComplete(function () {
									that.content = that.getView().querySelector('.pregamematchup');
									that.hideOverlay();
									that.setScroll(that.getView());
								});
							});
					});
			};
			GameDayCore.addListener(EventEnums.UPDATE, this.onBeat);
			this.onBeat();
		},

		viewWillAppear: function () {
			var that = this;
			this.showOverlay();
			Superclass.viewWillAppear.call(this);
		},

		viewWillDisappear: function () {
			// TODO below needs to be uncommented and include something about ... 'pregame_' + this.type
			GameDayCore.removeListener(EventEnums.UPDATE, this.onBeat);
			Superclass.viewWillDisappear.call(this);
		}
	});

	Superclass = PregameMatchupViewController.superclass;
	// Add view controller class to Gameday UI library
	return PregameMatchupViewController;
});
